module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/special-olympics-b8502c4669892defe55b3a90e114ec82.png";